import OriginTypography from './Typography';
import Text from './Text';
import Title from './Title';
import Paragraph from './Paragraph';
const Typography = OriginTypography;
Typography.Text = Text;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
export default Typography;
